export default {
  assetName: "Base Site",
  heading: "<em>Get Frontier Fiber</em> For Business",
  subheading:
    "No matter your business needs, we have a plan that's right for you.",
  backgroundImage: "",
  hasCta: true,
  hasSecondaryCta: true,
  customStyles: "",
  cardsCtaType: "cart",
  productsArray: [
    {
      id: "fiber500",
      heading: 'Business<br/>Fiber 500',
      copy: "Use for emailing, POS systems and web browsing",
      features: ["Advanced 6E Wi-Fi router included"],
    },
    {
      id: "fiberGig",
      heading: 'Business<br/>Fiber 1 Gig',
      copy:  "Ideal for HD videos, cloud backups and file sharing",
      features: ["Advanced 6E Wi-Fi router included"],
    },
    {
      id: "fiber2Gig",
      heading: 'Business<br/>Fiber 2 Gig',
      copy:  "Great for sharing large files, live streaming and cloud applications",
      features: [
        "Business grade internet without the premium cost",
        "Advanced 6E Wi-Fi router included",
      ],
    },
    {
      id: "fiber5Gig",
      heading: 'Business<br/>Fiber 5 Gig',
      copy:  "Seamless performance for video calls, cloud-based collaboration and large file transfers",
      features: ["Advanced 6E Wi-Fi router included"],
    },
    {
      id: 'fiber7Gig',
      heading: 'Business<br/>Fiber 7 Gig<br/>Ultra',
      copy: "Cutting-edge tech for nearly instant uploads, multi-device systems and ultimate reliability",
      features: ['Includes advanced phone solutions, security, internet backup and more', 'Advanced 6E Wi-Fi router + 1 advanced extender included'],
    },
  ],
};
